







































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Snackbar from '@/components/shared/Snackbar.vue';
import IRolePermission from '@/store/models/IRolePermission';
import IStock from '@/store/models/IStock';
import FilterMenu from '@/components/shared/FilterMenu.vue';
import { delay, difference, uniq, without } from "lodash";
import moment from 'moment';

@Component({
    components: {
        Snackbar,
        FilterMenu
    }
})
export default class CustomerStockSelector extends Vue {
    @Prop({ type: Array, required: true })
    Permissions !: IRolePermission[];
    @Prop({ type: Array, required: true })
    StockList !: IStock[];

    inboundCodeFilter : string[] = [];
    goodFilter : string[] = [];
    palletFilter : string[] = [];
    bestBeforeDateFilter : Date[] = [];
    groupByActive : boolean = false;
    stockError: string[] = [];
    location: string = "";
    dialog: boolean = false;
    selectedFormatToPrint: string = "excel";
    warehouseNameFilter: string[] = [];
    headers: any = [
        { text: 'Good',
            align: 'start',
            value: 'goodName'
        },
        { text: 'Dossier Number Source', value: 'codeInbounds' },
        { text: 'Pallet type', value: 'listPalletName' },
        { text: 'Total pallets', value: 'palletsAmount' },
        { text: 'Sell pallets', value: 'palletsAmountSell' },
        { text: 'Available pallets', value: 'availablePalletsAmountFinal' },
        { text: 'Total cases', value: 'totalCases' },
        { text: 'Cases Allocated', value: 'allocatedCases' },
        { text: 'Cases sell', value: 'sellCases' },
        { text: 'Available Cases', value: 'availableCasesFinal' },
        { text: 'Total goods', value: 'totalGoods' },
        { text: 'Goods Allocated', value: 'allocatedGoods' },
        { text: 'Goods sell', value: 'sellGoods' },
        { text: 'Available Goods', value: 'availableGoodsFinal' },
        { text: 'BestBeforeDate', value: 'bestBeforeDate' },
        { text: 'Reference dossier number', value: 'referenceInboundCode' },
        { text: 'Language', value: 'language' },
        { text: 'Documentation', value: 'documentation' }
    ];

    get TotalCases() {
        return this.stockItemsFiltered.reduce((sum, current) => Number(sum) + Number(current.totalCases), 0);
    }

    get TotalPallets() {
        let i : number = this.stockItemsFiltered.reduce((sum, current) => Number(sum) + Number(current.palletsAmount), 0);
        return i;
    }

    get TotalGoods() {
        return this.stockItemsFiltered.reduce((sum, current) => Number(sum) + Number(current.totalGoods), 0);
    }
    get warehouseNames(): string[] {
        return uniq(
            this.StockList
            .filter(b => b.warehouseName !== null && b.warehouseName !== undefined && b.warehouseName !== "")
            .map(b => b.warehouseName)
        );
    }
   
    ToDateFormat(date: string) : string {
        if (date === "" || date === null) {
            return "";
        }
        return moment(new Date(date)).format('DD-MM-YYYY');
    }

    get bestBeforeDates() : Date[] {
        return uniq(
            this.StockList
            .filter(b => b.bestBeforeDate !== null)
            .map(b => b.bestBeforeDate)
        );
    }

    get inboundCodes() : string[] {
        return uniq(
            this.StockList
            .filter(b => b.codeInbounds !== null)
            .map(b => b.codeInbounds)
        );
    }

    get goodNames() : string[] {
        return uniq(
            this.StockList
            .filter(b => b.goodName !== null)
            .map(b => b.goodName)
        );
    }

    get palletNames() : string[] {
        return uniq(
            this.StockList
            .filter(b => b.listPalletName !== null)
            .map(b => b.listPalletName)
        );
    }

    get stockItemsFiltered() : IStock[] {
        let filteredList = this.StockList;

        if (this.inboundCodeFilter.length > 0) {
            filteredList = filteredList.filter(b => this.inboundCodeFilter.includes(b.codeInbounds));
        }
        if (this.goodFilter.length > 0) {
            filteredList = filteredList.filter(b => this.goodFilter.includes(b.goodName));
        }
        if (this.palletFilter.length > 0) {
            filteredList = filteredList.filter(b => this.palletFilter.includes(b.listPalletName));
        }
        if (this.bestBeforeDateFilter.length > 0) {
            filteredList = filteredList.filter(b => this.bestBeforeDateFilter.includes(b.bestBeforeDate));
        }
        if (this.warehouseNameFilter.length > 0) {
            filteredList = filteredList.filter(b => this.warehouseNameFilter.includes(b.warehouseName));
        }
        return filteredList;
    }

    getBestBeforeStatus(dateStr: any): "expired" | "soon" | "normal" {
        if (!dateStr) return "normal";

        const today = moment().startOf("day");
        let date: moment.Moment;

        // 🔹 Si viene como Date (objeto), lo tratamos directo
        if (dateStr instanceof Date) {
            date = moment(dateStr).startOf("day");
        } else if (typeof dateStr === "string") {
            const trimmed = dateStr.trim();

            // Intentamos con varios formatos comunes
            date = moment(trimmed, ["DD/MM/YYYY", "D/M/YYYY", "YYYY-MM-DD", moment.ISO_8601], true)
            .startOf("day");
        } else {
            // Tipo raro → lo ignoramos
            return "normal";
        }

        if (!date.isValid()) {
            console.warn("Invalid bestBeforeDate:", dateStr);
            return "normal";
        }

        // 🟥 Caducado (antes de hoy)
        if (date.isBefore(today)) {
            return "expired";
        }

        // 🟨 A punto de caducar: menos de 90 días desde hoy
        const diffDays = date.diff(today, "days");

        if (diffDays >= 0 && diffDays < 90) {
            return "soon";
        }

        // 🟦 Tranquilo, falta más de 3 meses
        return "normal";
    }

    // Para asignar color del v-chip según estado
    getBestBeforeColor(status: "expired" | "soon" | "normal") {
        switch (status) {
            case "expired":
                return "red darken-2";
            case "soon":
                return "yellow darken-2";
            default:
                return "blue-grey lighten-2";
        }
    }

    clearAllFilters() : void {
        this.inboundCodeFilter = [];
        this.goodFilter = [];
        this.palletFilter = [];
        this.bestBeforeDateFilter = [];

        // ✅ AÑADIR
        this.warehouseNameFilter = [];

        this.showMessageInfo("All filters have been deselected");
    }

    printStock() {
        this.$emit(
            'printCustomerStock',
            this.selectedFormatToPrint,
            this.warehouseNameFilter,
            this.bestBeforeDateFilter,
            this.inboundCodeFilter,
            this.goodFilter
        );
    }

    showMessageInfo(message: string) {
        (this.$refs.snackbar as Snackbar).showInfo(message);
    }

    showMessageError(message: string) {
        (this.$refs.snackbar as Snackbar).showError(message);
    }
    
    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }
}
